<template>
  <div class="v-counter theme--light" style="font-size: 15px;">{{ result }}</div>
</template>

<script>
export default {
  name: 'Counter',
  data: () => ({
    result: '',
    counter_buffer: 0,
  }),
  props: {
    message: String,
    type: String,
  },
  methods: {
    count() {
      let counter = 0;
      for (let i = 0; i < this.message.length; i += 1) {
        counter += 1;
      }
      if (counter < 2000) {
        this.result = `1 Mesaj / ${counter} Karakter`;
      } else {
        this.result = 'Mesaj uzunluğu 2000 karakterden fazla olmamalı.';
      }
      this.counter_buffer = counter;
    },
  },
  watch: {
    message() {
      this.count();
    },
    type() {
      this.count();
    },
  },
  mounted() {
    this.count();
  },
  events: {
    // eslint-disable-next-line func-names
    'force:recount': function () {
      this.count();
    },
    // eslint-disable-next-line func-names
    'get:count': function () {
      return this.counter_buffer;
    },
  },
};
</script>
